import { Api, IApiResponse } from '../api';
import { ConfigurationDto } from '../models';

export const get = (accessToken?:string): Promise<IApiResponse<ConfigurationDto>> => Api.get('Configuration', accessToken);

export const update = (configuration: ConfigurationDto) => Api.put('Configuration', configuration);
